module.exports = __webpack_public_path__ + "img/image.ac901130.png";